import * as React from 'react';

import * as styles from './styles.css';

export const CommunicationWaitIllustration: React.FC = () => {
  return <div className={styles['wait']} />;
};
